import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { KomponentTypeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/komponent-type-dto';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { KomponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/komponent-dto';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnlaegKomponentDialogData } from '../../models';
import { interval, Subject } from 'rxjs';
import { distinctUntilChanged, debounce, takeUntil } from 'rxjs/operators';
import moment from 'moment';

@Component({
    selector: 'app-anlaegs-komponent',
    templateUrl: './anlaegs-komponent.component.html',
    styleUrls: ['./anlaegs-komponent.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnlaegsKomponentComponent implements OnInit, OnDestroy {
  komponenter?: KomponentDto[];
  komponentTyper: KomponentTypeDto[];
  form: UntypedFormGroup;
  editMode: Boolean = false;
  matchingKomponenter: KomponentDto[];
  minInstallDate: Date;
  unsubscribe$ = new Subject<void>();

  get komponentTypeId() {
    return this.form.get('komponentTypeId');
  }
  get model() {
    return this.form.get('model');
  }
  get serienummer() {
    return this.form.get('serienummer');
  }
  get installationDate() {
    return this.form.get('installationDate');
  }
  get garantiPeriode() {
    return this.form.get('garantiPeriode');
  }

  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<AnlaegsKomponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AnlaegKomponentDialogData
  ) {}

  ngOnInit(): void {
    this.editMode = this.data.editMode;
    this.minInstallDate = this.data.minInstallDate;
    this.komponentTyper = this.data.komponentTyper;
    this.komponenter = this.data.komponenter;

    this.form = this.fb.group({
      komponentTypeId: ['', [Validators.required]],
      model: ['', Validators.required],
      serienummer: [''],
      installationDate: [null],
      garantiPeriode: [null, [Validators.max(1200), Validators.pattern('^\\d+$')]],
    });

    if (this.data.editMode) {
      this.initializeEdit();
    }

    this.serienummer.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        debounce(() => interval(750))
      )
      .subscribe((serienummer) => {
        this.matchingKomponenter = this.komponenter.filter((x) => x.serienummer == serienummer);
      });

    this.installationDate.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      if (!val) {
        this.garantiPeriode.disable();
        this.garantiPeriode.setValue(null);
      } else {
        this.garantiPeriode.enable();
      }
    });

    if (!this.installationDate.value) {
      this.garantiPeriode.setValue(null);
      this.garantiPeriode.disable();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  initializeEdit() {
    this.form.markAllAsTouched();
    this.form = this.data.komponent;
  }

  isComponentOlder() {
    return moment(this.installationDate.value).isBefore(moment(this.minInstallDate));
  }

  save() {
    this.dialog.close(this.form); //this.komponent);
  }

  cancel() {
    this.dialog.close(null);
  }
}
